import React from 'react';
import Icon from '../icons/Icon';
import './HeaderEvent.scss';
import { useEvent } from '../../../data/hooks/eventHooks';

function HeaderEvent(props) {
    const {className = '', eventId} = props,
        event = useEvent(eventId);

    if (!event) return null;

    return (
        <h2 className={['HeaderEvent', className].join(' ')}>
            <Icon src={event.icon_url} altSrc={''} />
            {event.name}
        </h2>
    );
}

export default HeaderEvent;
